export const config = {
  title: 'GM Services Landscaping & Construction',
  meta: {
    description: 'GM Services Landscaping & Construction offers professional landscaping and construction services in Minnesota, specializing in both residential and commercial projects.',
    keywords: [
      'Landscaping Services',
      'Construction Services',
      'Minnesota Landscaping',
      'Residential Landscaping',
      'Commercial Landscaping',
      'GM Services Landscaping & Construction',
    ],
    author: 'GM Services Landscaping & Construction',
    canonicalUrl: 'https://www.gmserviceslandscapingconstruction.com/',
  },
  sections: {
    header: {
      businessName: 'GM Services Landscaping & Construction',
    },
    sectionB: {
      heroTitle: 'GM Services Landscaping & Construction',
      heroSubtitle: 'Professional Landscaping and Construction Services in Minnesota',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '6512264181',
      phoneLabel: '(651) 226-4181',
      heroBackgroundImage: 'https://media.istockphoto.com/id/1324918160/photo/professional-gardener-trimming-hedge.jpg?s=612x612&w=0&k=20&c=zumBbqam7P2pNpoGMrca4RhZGWW7zfRDUDE2zqABJTs=',
      cardData: [
        {
          title: 'Quality Craftsmanship',
          description: 'Delivering top-notch landscaping and construction services with attention to detail.',
        },
        {
          title: 'Customer Satisfaction',
          description: 'Committed to exceeding client expectations through exceptional service.',
        },
        {
          title: 'Experienced Professionals',
          description: 'A team of skilled experts dedicated to transforming your outdoor spaces.',
        },
      ],
      description: 'At GM Services Landscaping & Construction, we specialize in creating beautiful and functional outdoor spaces for both residential and commercial clients in Minnesota.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription: 'Explore our range of professional landscaping and construction services tailored to meet your needs.',
      cards: [
        {
          title: 'Landscape Design',
          description: 'Custom landscape designs that enhance the beauty and functionality of your property.',
          imageSrc: 'https://media.istockphoto.com/id/612495778/photo/gardener-at-gardening.jpg?s=612x612&w=0&k=20&c=4Rs5qIlRaPvOcFJqsWzQ5-vLG-6OiIifeYF-eLF-5Jc=',
          imageAlt: 'Landscape Design',
        },
        {
          title: 'Hardscaping',
          description: 'Expert installation of patios, walkways, and retaining walls to complement your landscape.',
          imageSrc: 'https://media.istockphoto.com/id/2166369789/photo/worker-power-washing-a-garden-pathway-in-a-residential-outdoor-space-during-daylight.jpg?s=612x612&w=0&k=20&c=fUtwAvzC2G4UWzyOeuNWp2_gxnHiwNnKlLMNN3oW_iM=',
          imageAlt: 'Hardscaping',
        },
        {
          title: 'Lawn Maintenance',
          description: 'Comprehensive lawn care services to keep your yard looking pristine.',
          imageSrc: 'https://media.istockphoto.com/id/1233240624/photo/worker-mowing-tall-grass-with-electric-or-petrol-lawn-trimmer-in-city-park-or-backyard.jpg?s=612x612&w=0&k=20&c=0vzwO6cvsBpchDzBaX-XF31_sCC-Z3cL8y-HeRmd7PY=',
          imageAlt: 'Lawn Maintenance',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Irrigation Systems',
        'Tree Planting & Removal',
        'Seasonal Cleanups',
        'Snow Removal',
        'Outdoor Lighting',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.squarespace-cdn.com/content/v1/67e9e28816ddf34c9577e8fc/744f70db-c85e-4eaa-8526-73e2d97349c4/IMG_4095.jpg?format=750w',
        alt: 'GM Services Landscaping & Construction Team',
      },
      aboutText: [
        'GM Services Landscaping & Construction is dedicated to providing high-quality landscaping and construction services in Minnesota.',
        'Our team works closely with clients to bring their vision to life, ensuring each project reflects their unique preferences and needs.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'GM Services Landscaping & Construction Logo',
      businessName: 'GM Services Landscaping & Construction',
      contact: {
        phone: '6512264181',
        phoneLabel: '(651) 226-4181',
        email: 'gmserviceslandscape@gmail.com',
        website: 'https://www.gmserviceslandscapingconstruction.com/',
        address: 'Minnesota, MN 55076',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Minnesota, MN 55076',
      googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56546.4580321825!2d-93.0710781!3d44.8263851!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87f62d1fc74e72bb%3A0x7b5a1b6de73b383a!2sInver%20Grove%20Heights%2C%20MN%2055076%2C%20USA!5e0!3m2!1sen!2sus!4v1712601180555!5m2!1sen!2sus",
    },
  },
};

export default config;
